import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";

class FallaDesembarque extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'falla-desembarque/one', saveUrl: 'falla-desembarque/save', backUrl: '/Catalogo/FallasDesembarques' },
      new Form([
        Form.Field('text', 'falla_desmb_falla', 'Clave', '', [Validators.required], 4),
        Form.Field('text', 'falla_desmb_nombre', 'Nombre', '', [Validators.required], 8),
      ], ['Guardar'], 'Concepto de Falla de Desembarque'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(FallaDesembarque)
